import React from 'react';
import PageHeader from '../shared/page-header';
import { connect } from 'react-redux';
import { Link } from 'react-router';

const Download = ({ pathname, children }) => {
    if(pathname === '/download') {
        return (
            <div>
                <PageHeader><span>Downloads</span></PageHeader>
                <div className="row">
                    <div className="col-sm-12">
                        <div>
                            <div>
                                <h2 style={{marginTop: 0}}>Claware</h2>
                                <p>Claware is a software application specifically designed for efficiently filing, cross-referencing, retrieving, and analyzing the data gathered during the process of learning a new culture and language, enabling cross-cultural workers to spend less time managing their data and more time building relationships with people.</p>
                                <Link to="/download/claware"><button style={{minWidth: 200}} type="button" className="btn btn-primary"><i className="fa fa-download"></i> Download Claware</button></Link>
                            </div>
                            <div>
                                <h2>Map Creator</h2>
                                <p>Map Creator simplifies the creation of language-specific maps, charts, and diagrams for lessons and world geography.</p>
                                <a href="http://fmosoft.com/download"><button style={{minWidth: 200}} type="button" className="btn btn-primary"><i className="fa fa-download"></i> Download Map Creator</button></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    } else {
        return (
            <div>
                {children}
            </div>
        );
    }

};
Download.propTypes = {
    pathname: React.PropTypes.string,
    children: React.PropTypes.element
};

const DownloadContainer = connect(
    ({ routing }) => {
        const { pathname } = routing.locationBeforeTransitions;
        return {
            pathname
        };
    },
    null
)(Download);

export default DownloadContainer;



// WEBPACK FOOTER //
// ./src/components/download/download.js